import styled from "styled-components";
import { width } from "styled-system";

export const DesktopMain = styled.div`
  width: 100%;
  min-width: 0;
  min-height: 744px;
  opacity: 1;
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
`;

export const BannerLayout = styled.div`
  width: 100%;
  max-width: 1200px;
  height: auto;
  gap: 20px;
  opacity: 1;
  border-radius: 16px;
  overflow: hidden;
  flex-shrink: 0;
  margin-top: 40px;
  margin-left: 47.5px;
  margin-right: 47.5px;
`;

export const WelcomeHeading = styled.p`
  font-size: 24px;
  font-weight: 700;
  color: #293142;
  letter-spacing: -0.24px;
  margin: 0 0 8px;
`;

export const WelcomeSubtext = styled.p`
  font-size: 16px;
  color: #767c8f;
  margin: 0 0 32px;
`;

export const ContentCenter = styled.div`
  min-height: fit-content;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-block: 48px;
`;

export const QuickActionPills = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const cardContainer = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '15px',
  height: '400px',
  width: '400px',
};

export const card = {
  width: '221.02px',
  height: '69.51px',
  background: 'rgba(255, 255, 255, 1)',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  padding: '0 16px',
  gap: '16px',
  boxShadow: '-8.89px 8.89px 0px 0px rgba(212, 219, 227, 1)',
};

export const coloredSquare = {
  width: '31.73px',
  height: '31.73px',
  borderRadius: '6px',
  flexShrink: 0,
};

export const linesWrapper = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '6px',
};

export const greyLine = (isWide) => ({
  width: isWide ? '105px' : '70px',
  height: '9px',
  background: 'rgba(212, 219, 227, 1)',
  borderRadius: '4px',
});

export const Pill = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  background: #ffffff;
  border: none;
  border-radius: 10px;
  box-shadow: 0px 1px 2px rgba(28, 28, 28, 0.06);
  font-size: 16px;
  font-weight: 500;
  color: #293142;
  cursor: pointer;

  svg {
    width: 12px;
    height: 12px;
  }
`;
